import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { DeliveryWhereInput, PaginationInputType } from '@/gql/graphql';

// Fragments
import './fragments/scheduledDeliveriesDetailedFragment';
import './fragments/scheduledDeliveriesSimpleFragment';

export const getGourmetScheduledOrders = async ({
  where,
  pagination,
  startDate,
  endDate,
  isDetail,
}: {
  where: DeliveryWhereInput;
  pagination?: PaginationInputType;
  startDate?: string;
  endDate?: string;
  isDetail?: boolean;
}) => {
  const query = isDetail
    ? graphql(`
        query GetScheduledOrdersDetailed(
          $where: DeliveryWhereInput!
          $pagination: PaginationInputType
          $startDate: String
          $endDate: String
        ) {
          getScheduledOrders(where: $where, pagination: $pagination, startDate: $startDate, endDate: $endDate) {
            ...ScheduledDeliveriesDetailedFragment
          }
        }
      `)
    : graphql(`
        query GetScheduledOrdersSimple(
          $where: DeliveryWhereInput!
          $pagination: PaginationInputType
          $startDate: String
          $endDate: String
        ) {
          getScheduledOrders(where: $where, pagination: $pagination, startDate: $startDate, endDate: $endDate) {
            ...ScheduledDeliveriesSimpleFragment
          }
        }
      `);

  const response = await queryExecute({
    query,
    variables: {
      where,
      pagination,
      startDate,
      endDate,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.getScheduledOrders;
};
